import { ClipboardList } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';

type Props = {
    onClick: () => void;
    className?: string;
};

export function RecordingRecapChecklistButton({ onClick, className }: Props) {
    return (
        <Button
            type="button"
            variant="outline"
            className={cn('gap-2', className)}
            onClick={onClick}
        >
            <ClipboardList className="size-4" />
            <span>Recap Checklist</span>
        </Button>
    );
}
